import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Edit from './edit';
import Save from './save';

registerBlockType( metadata.name, {
	edit: Edit,
	save: Save,
	icon: {
		foreground: '#0061FE',
		src: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				width="24"
				height="24"
			>
				<rect
					x="3"
					y="4"
					width="18"
					height="16"
					rx="1.5"
					fill="none"
					stroke="currentColor"
					strokeWidth="1.5"
				/>
				<path d="M7 9h10M7 12h7" opacity=".4" />
			</svg>
		),
	},
} );
